import { render, staticRenderFns } from "./VaInput.demo.vue?vue&type=template&id=0df303f0&"
import script from "./VaInput.demo.vue?vue&type=script&lang=js&"
export * from "./VaInput.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports